import type {z} from "zod";

import {ListServiceFunctionsQueryParams} from "@project/sdk/engineering/zod";

export const listServiceFunctionsSearchSchema = ListServiceFunctionsQueryParams.extend({
  page: ListServiceFunctionsQueryParams.shape.page.catch(1).default(1),
  perPage: ListServiceFunctionsQueryParams.shape.perPage.catch(20).default(20),
  q: ListServiceFunctionsQueryParams.shape.q.catch(undefined),
  state: ListServiceFunctionsQueryParams.shape.state.catch("ACTIVE"),
  sortKey: ListServiceFunctionsQueryParams.shape.sortKey.catch("serviceFunctionId"),
  sortDir: ListServiceFunctionsQueryParams.shape.sortDir.catch("asc").default("asc"),
});

export type ListServiceFunctionsSearchInput = z.input<typeof listServiceFunctionsSearchSchema>;
export type ListServiceFunctionsSearch = z.output<typeof listServiceFunctionsSearchSchema>;
